import Vue from 'vue'
import Vuex from 'vuex'
import { catchError } from '../util'
import Setting from './modules/setting'
import Organize from './modules/organize'
import Customer from './modules/customer'
import Role from './modules/role'
import Permission from './modules/permission'
import Subject from './modules/subject'
import Contract from './modules/contract'
import Account from './modules/account'
import HelpCenter from './modules/helpCenter'
import Message from './modules/message'
import Business from './modules/business'
import PopperConfig from './modules/popperConfig'
import {Req_GetMenuList} from '@/request/menu'
import {
  Req_GetUserInfo,
  Req_GetCompanyDetail,
  Req_RestGetPermissionConfig
} from '@/request/user'
Vue.use(Vuex)

Vuex.Store.prototype.$catchErr = catchError

function handleNeedSecondMenu(list){
  list.forEach(item => {
    if(item.isAuthorized){
      store.state.needSecondMenu[item.path] = item
    }
    if(item.children && item.children.length > 0){
      handleNeedSecondMenu(item.children)
    }
  });
}

const store = new Vuex.Store({
  state: {
    loading: false,
    showErrTips:true,
    showCheckPassword:false,
    menuCollapse: true,
    userInfo:null,
    companyInfo: null,
    pageSize: 50,
    menu: [],
    needSecondMenu:{},
    permissionList:[],
    
  },
  mutations: {
    setErrorTipsShowState(state,isShow){
      state.showErrTips = isShow
    },
    setShowCheckPassword(state,isShow) {
      state.showCheckPassword = isShow
    },
    setPageSize(state,size) {
      state.pageSize = size
    },
    refreshMenuCollapse(state) {
      state.menuCollapse = !state.menuCollapse
    },
    refreshLoadingState(state,payload) {
      if(!payload) {
        state.loading = false
      }else {
        state.loading = payload
      }
    },
    refreshUserInfo(state,payload) {
      state.userInfo = payload
    },
    removeUserInfo(state) {
      state.userInfo = null
    },
    removeCompanyInfo(state) {
      state.companyInfo = null
    },
    refreshCompanyInfo(state,payload) {
      state.companyInfo = payload
    },
    initMenu(state,payload) {
      state.menu = payload
      handleNeedSecondMenu(payload)
    },
    clearNeedSecondMenu(state,payload){
      state.needSecondMenu = {}
    },
    initPermissionList(state,payload){
      state.permissionList = payload
    },
    removePermission(state){
      state.permissionList = []
    }
  },
  actions: {
    getUserInfo(store) {
      Req_GetUserInfo().then(res => {
        store.commit('refreshUserInfo',res)
      }).catch(err => this.$catchErr(err))
    },
    getCompanyInfo(store) {
      Req_GetCompanyDetail().then(res => {
        store.commit('refreshCompanyInfo',res)
      }).catch(err => this.$catchErr(err))
    },
    getMenuList(store,payload) {
      return new Promise((resolve,reject) => {
        Req_GetMenuList({
          platformType: 20
        }).then(res => {
          store.commit('initMenu',res.content)
          resolve(res.content)
        }).catch(err => {
          reject()
        })
      })
    },
    getPermissionConfig(store,payload) {
        Req_RestGetPermissionConfig().then(res => {
          store.commit('initPermissionList',res)
        }).catch(err => console.log(err))
    }
  },
  modules: {
    Setting,
    Organize,
    Customer,
    Role,
    Permission,
    Subject,
    Contract,
    Account,
    HelpCenter,
    PopperConfig,
    Message,
    Business
  }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js